// extracted by mini-css-extract-plugin
export default {"description":"style_description__QL5DG","fade-in":"style_fade-in__UYQlx","top":"style_top__a+IH2","image":"style_image__JsPIZ"};